/**
 * <mb-accordion>: acordeão do FAQ (portado de pages/tag.js accordionsFaq + utilities.js slideToggle/slideDown).
 * Abre e fecha por altura animada; se a URL trouxer o âncora de um item, abre e rola até ele no carregamento.
 */
class MbAccordion extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-collapse]'));
    if (!this.items.length) return;

    this.items.forEach((item) => {
      const handle = item.querySelector('[data-collapse-handle]');
      handle?.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggle(item);
      });
    });

    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target && this.items.includes(target)) {
        this.open(target);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: target.offsetTop - 200, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
  }

  toggle(item) {
    if (item.classList.contains('-open')) this.close(item);
    else this.open(item);
  }

  open(item) {
    const wrapper = item.querySelector('.content-wrapper');
    const content = item.querySelector('.content');
    if (!wrapper || !content) return;
    item.classList.add('-open');
    item.querySelector('[data-collapse-handle]')?.setAttribute('aria-expanded', 'true');
    wrapper.style.height = `${content.clientHeight}px`;
  }

  close(item) {
    const wrapper = item.querySelector('.content-wrapper');
    if (!wrapper) return;
    item.classList.remove('-open');
    item.querySelector('[data-collapse-handle]')?.setAttribute('aria-expanded', 'false');
    wrapper.style.height = '0px';
  }
}

if (!customElements.get('mb-accordion')) customElements.define('mb-accordion', MbAccordion);
